export const categoryData = [
  { id: "refill", name: "Поповнення" },
  { id: "writing_off", name: "Списання" },
];
